
import { Button, Card, Col, DatePicker, Form, Input, Modal, Row, Select, Table, Tag } from 'antd';
import { ColumnProps } from 'antd/es/table';
import { ProdlogService } from 'libs/shared-services/production/src/lib/prod-log.service';
import React, { useEffect, useRef, useState } from 'react';
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { OperationTypeEnum } from 'libs/shared-models/common-models/src/lib/enum/operation-type.enum';
import { JobReportingInfoReq } from '@gtpl/shared-models/production-management';
import moment from 'moment';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import Link from 'antd/lib/typography/Link';
import { LotDetailView } from '@gtpl/pages/production-management/production-management-components/lot-detail-view';
import { GlobalVariableValues, PassOrFail } from '@gtpl/shared-models/common-models';
import { Excel } from "antd-table-saveas-excel";



const { Option } = Select;
const { Item: FormItem } = Form;

export const ReportingInfo = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const service = new ProdlogService();
  const [data, setData] = useState<any[]>([]);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [lotINo, setLotINo] = useState('lotNumber');
  const [year,setYear]=useState<any>()

  const [form] = Form.useForm();
  const [selectedRange, setSelectedRange] = useState('days');
  const [lotNumbers, setLotNumbers] = useState<any[]>([]);
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const operationOptions = [
    ...Object.values(OperationTypeEnum),
    'NON-SOAKED',
  ];
  

  const initialDateRange = [moment().subtract(7, 'days'), moment()];


  useEffect(() => {
    form.setFieldsValue({
      dateRange: initialDateRange
    });
    getInfo({
      dateRange: initialDateRange
    });
    fetchLotNumbers();
  }, []);

  const fetchLotNumbers = async () => {
    try {
      const res = await service.getLotNumberDetails();
      if (res.status) {
        setLotNumbers(res.data);
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    } catch (err) {
      AlertMessages.getErrorMessage(err.message);
    }
  };

  const normalizeReportingRow = (row: any) => ({
    ...row,
    operation: row.operation ?? row.operationType,
    outputGrade: row.outputGrade ?? row.actualGrade,
    outputQuantity: row.outputQuantity ?? row.actualOutputQuantity,
    workstationType: row.workstationType ?? row.workStationType,
  });

  const getInfo = (values: any = {}) => {
    const req = new JobReportingInfoReq()
    if(form.getFieldValue('lotNumber') != undefined){
      req.lotNumber = form.getFieldValue('lotNumber')
    }
    if(form.getFieldValue('operation') != undefined){
      const selectedOperations = form.getFieldValue('operation');
      req.operation = Array.isArray(selectedOperations)
        ? selectedOperations.join(',')
        : selectedOperations;
    }
    if (form.getFieldValue('prevOperation') != undefined) {
      const selectedPrevOperations = form.getFieldValue('prevOperation');
      (req as any).prevOperation = Array.isArray(selectedPrevOperations)
        ? selectedPrevOperations.join(',')
        : selectedPrevOperations;
    }
    if(form.getFieldValue('status') != undefined){
      req.status = form.getFieldValue('status') 
    }
    if (form.getFieldValue('dateRange') != undefined) {
      req.fromDate = form.getFieldValue('dateRange')[0].format('YYYY-MM-DD');
      req.toDate = form.getFieldValue('dateRange')[1].format('YYYY-MM-DD');
    }
    // if (values.lotNumber) {
    //   req.lotNumber = values.lotNumber;
    // }
    // if (values.operation) {
    //   req.operation = values.operation;
    // }
    
    service.getAllReportingInfo(req).then((res) => {
      if (res.status) {
        setData((res.data || []).map((row: any) => normalizeReportingRow(row)));
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setData([]);
      }
    })
    .catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setData([]);
    });
    
  };

  const goToLotDetailView = (lotNumber: string,year:number) => {
    setLotINo(lotNumber);
    setYear(year)
    console.log("lotNo", lotNumber);
    setIsModalVisible(true)
}
const handleCancel = () => {
  setIsModalVisible(false);
};

  const onReset = () => {
    form.resetFields();
    form.setFieldsValue({
      dateRange: initialDateRange
    });
    getInfo({
      dateRange: initialDateRange
    });
  };
  const onFinish = (values: any) => {
    getInfo(values);
  };
  const { RangePicker, MonthPicker } = DatePicker;

  // const handleDateRangeChange = (value) => {
  //   setSelectedRange(value);
  //   form.resetFields(['dateRange']);
  // };

  const renderDatePicker = () => {
    if (selectedRange === 'days') {
      return <RangePicker />;
    } else if (selectedRange === 'months') {
      return <RangePicker picker="month" />;
    } else if (selectedRange === 'years') {
      return <RangePicker picker="year" />;
    }
  };

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

    const handleExport = (e: any) => {
    e.preventDefault();

    const currentDate = new Date()
        .toISOString()
        .slice(0, 10)
        .split("-")
        .join("/");

    let rowIndex = 1;
    let exportingColumns: any[] = []
    exportingColumns.push(
        {
            title: "S.No",
            width: 50,
            render: (text, object, index) => {
                if (index == data.length) {
                    return null;
                } else {
                    return rowIndex++;
                }
            }
        },
         {
      title: 'Lot Number',
      dataIndex: 'lotNumber',
       render:(text)=> text ? text : '-',
    
    },
       
    {
      title: 'Previous Operation',
      dataIndex: 'prevOperation',
            render:(text)=> text ? text : '-',
    },
    
    {
      title: 'Operation',
      dataIndex: 'operation',
       render:(text)=> text ? text : '-',

    },
    {
      title: 'Date',
      dataIndex: 'date',
      render:(text)=> text ? moment(text).format('YYYY-MM-DD') : '-',
    },
   
    {
      title: 'Input Grade',
      dataIndex: 'inputGrade',
      render:(text)=> text ? text : '-',

    },
    {
      title: 'Output Grade',
      dataIndex: 'outputGrade',
       render:(text)=> text ? text : '-',

    },
    {
      title: 'Input Quantity',
      dataIndex: 'inputQuantity',
      render: (text) => text != null ? Number(text) : '',
    },
    {
      title: 'Output Quality',
      dataIndex: 'outputQuantity',
      render: (text) => text != null ? Number(text) : ''
    },
   
   
    {
      title: 'Input Product',
      dataIndex: 'inputProduct',
      render:(text)=> text ? text : '-',
    },
    {
      title: 'Output Product',
      dataIndex: 'outputProduct',
      render:(text)=> text ? text : '-',
    },
    {
      title: 'Entry Type',
      dataIndex: 'entryType',
      render:(text)=> text ? text : '-',
    },
    {
      title: 'Input Count Type',
      dataIndex: 'inputCountType',
      render:(text)=> text ? text : '-',
    },
    {
      title: 'Output Count Type',
      dataIndex: 'outputCountType',
      render:(text)=> text ? text : '-',
    },
    {
      title: 'Input Grade Count',
      dataIndex: 'inputGradeCount',
      render:(text)=> text ? text : '-',
    },
    {
      title: 'Actual Grade Count',
      dataIndex: 'actualGradeCount',
      render:(text)=> text ? text : '-',
    },
    
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      render:(text)=> text ? text : '-',
    },
   
    {
      title: 'Year',
      dataIndex: 'year',
      render:(text)=> text ? text : '-',

    },
        
    );





    const excel = new Excel();
    excel.addSheet("Reporting Info");
    excel.addColumns(exportingColumns);
    excel.addDataSource(data);
    excel.saveAs(`Reporting Info-${currentDate}.xlsx`);
};

 const columns: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sNo',
      responsive: ['sm'],
      fixed: 'left',
      render: (text, object, index) =>
        (page - 1) * pageSize + (index + 1) + pageSize * (page - 1),
    },
    {
      title: 'Date',
      dataIndex: 'date',
      ...getColumnSearchProps('date'),
      fixed: 'left',
      render:(text)=> text ? moment(text).format('YYYY-MM-DD') : '-',
      sorter: (a, b) => moment(a.date).valueOf() - moment(b.date).valueOf(),
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Lot Number',
      dataIndex: 'lotNumber',
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('lotNumber'),
      fixed: 'left',
      sorter: (a, b) => a.lotNumber?.localeCompare(b.lotNumber),
      render: (value, record) =>
        <Link onClick={e => goToLotDetailView(record.lotNumber,record.year)} >{record.lotNumber}</Link>
    },
    {
      title: 'Entry Type',
      dataIndex: 'entryType',
      ...getColumnSearchProps('entryType'),
      fixed: 'left',
      render:(text)=> text ? text : '-',
      sorter: (a, b) => (a.entryType || '').localeCompare(b.entryType || ''),
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      ...getColumnSearchProps('operation'),
        sorter: (a, b) => a.operation?.localeCompare(b.operation),
      sortDirections: ['descend', 'ascend'],
       render:(text)=> text ? text : '-',

    },
    {
      title: 'Previous Operation',
      dataIndex: 'prevOperation',
      ...getColumnSearchProps('prevOperation'),
            render:(text)=> text ? text : '-',
      sorter: (a, b) => a.prevOperation?.localeCompare(b.prevOperation),
      sortDirections: ['descend', 'ascend'],
    },
    
    
    
    
    // {
    //   title: 'Input Grade',
    //   dataIndex: 'inputGrade',
    //   render:(text)=> text ? text : '-',
    //    sorter: (a, b) => a.inputGrade - b.inputGrade,
    //   sortDirections: ['descend', 'ascend'],

    // },
    // {
    //   title: 'Output Grade',
    //   dataIndex: 'outputGrade',
    //    render:(text)=> text ? text : '-',
    //   sorter: (a, b) => a.outputGrade?.localeCompare(b.outputGrade),
    //   sortDirections: ['descend', 'ascend'],

    // },
    {
      title: 'Input Quantity',
      dataIndex: 'inputQuantity',
      
        sorter: (a, b) => a.inputQuantity?.localeCompare(b.inputQuantity),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('inputQuantity'),
      render: (value) => Number(Number(value).toFixed(2)),
    },
    {
      title: 'Input Product',
      dataIndex: 'inputProduct',
      ...getColumnSearchProps('inputProduct'),
      render:(text)=> text ? text : '-',
      sorter: (a, b) => (a.inputProduct || '').localeCompare(b.inputProduct || ''),
      sortDirections: ['descend', 'ascend'],
    },
    
    
   {
      title: 'Input Count Type',
      dataIndex: 'inputCountType',
      ...getColumnSearchProps('inputCountType'),
      render:(text)=> text ? text : '-',
      sorter: (a, b) => (a.inputCountType || '').localeCompare(b.inputCountType || ''),
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Input Count',
      dataIndex: 'inputGradeCount',
      ...getColumnSearchProps('inputGradeCount'),
      render:(text)=> text ? text : '-',
      sorter: (a, b) => (a.inputGradeCount || '').localeCompare(b.inputGradeCount || ''),
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Output Quantity',
      dataIndex: 'outputQuantity',
      sorter: (a, b) => (Number(a.outputQuantity) || 0) - (Number(b.outputQuantity) || 0),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('outputQuantity'),
      render: (value) => Number(Number(value).toFixed(2)),

    },
    {
      title: 'Output Product',
      dataIndex: 'outputProduct',
      ...getColumnSearchProps('outputProduct'),
      render:(text)=> text ? text : '-',
      sorter: (a, b) => (a.outputProduct || '').localeCompare(b.outputProduct || ''),
      sortDirections: ['descend', 'ascend'],
    },
    
    
    {
      title: 'Output Count Type',
      dataIndex: 'outputCountType',
      ...getColumnSearchProps('outputCountType'),
      render:(text)=> text ? text : '-',
      sorter: (a, b) => (a.outputCountType || '').localeCompare(b.outputCountType || ''),
      sortDirections: ['descend', 'ascend'],
    },
    
    {
      title: 'Output Count',
      dataIndex: 'actualGradeCount',
      ...getColumnSearchProps('actualGradeCount'),
      render:(text)=> text ? text : '-',
      sorter: (a, b) => (a.actualGradeCount || '').localeCompare(b.actualGradeCount || ''),
      sortDirections: ['descend', 'ascend'],
    },
    
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      ...getColumnSearchProps('remarks'),
      render:(text)=> text ? text : '-',
      sorter: (a, b) => (a.remarks || '').localeCompare(b.remarks || ''),
      sortDirections: ['descend', 'ascend'],
    },
   
    {
      title: 'Year',
      dataIndex: 'year',
      ...getColumnSearchProps('year'),
            render:(text)=> text ? text : '-',
      sorter: (a, b) => a.year - b.year,
      sortDirections: ['descend', 'ascend'],

    },
  ];

  // Deduplicate by lot_number, prefer the one with lotNumber not null
const uniqueLotNumbers = lotNumbers.reduce((acc, lot) => {
  const existing = acc.find(l => l.lot_number === lot.lot_number);
  if (!existing) {
    acc.push(lot);
  } else if (lot.lotNumber !== null && existing.lotNumber === null) {
    // Replace null entry with the one that has a year
    return acc.map(l => l.lot_number === lot.lot_number ? lot : l);
  }
  return acc;
}, [] as typeof lotNumbers);

  return (
    <Card
    title={

        <span style={{ color: "white" }}>Reporting Info</span>
    }
    style={{ textAlign: "center" }}
    headStyle={{ backgroundColor: "#69c0ff", border: 0 }}
    extra={
      <Row>
        {data.length > 0 ? <Button
        onClick={handleExport}
        icon={<DownloadOutlined />}>Get Excel</Button> : null}
        <br/>
       
        
      </Row>
    }
  >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={24}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 4 }}>
            <FormItem name='lotNumber' label='Lot Number'>
              <Select 
                placeholder='Select Lot Number' 
                allowClear 
                showSearch 
                optionFilterProp='children'
                filterOption={(input, option) =>
                  (option?.children as string)
                    ?.toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {uniqueLotNumbers.map((lot) => (
                  <Option key={lot.lot_number} value={lot.lot_number}>
                    {lot.lot_number}
                  </Option>
                ))}
              </Select>
            </FormItem>
          </Col>
           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <FormItem name='prevOperation' label='Previous Operation'>
              <Select mode='multiple' placeholder='Select previous operation' allowClear>
                {operationOptions.map((operation) => (
                  <Option key={`prev-${operation}`} value={operation}>
                    {operation}
                  </Option>
                ))}
              </Select>
            </FormItem>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <FormItem name='operation' label='Operation' 
            // rules={[{ required: true }]}
            >
              <Select mode='multiple' placeholder='Select operation' allowClear >
                {operationOptions.map((operation) => (
                  <Option key={operation} value={operation}>
                    {operation}
                  </Option>
                ))}
              </Select>
            </FormItem>
          </Col>
         
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <FormItem name='dateRange' label='Date Range' >
            {renderDatePicker()}
            </FormItem>
          </Col>
          

          
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 3 }} style={{ marginTop:'29px' }}>
            <Form.Item>
              <Button type="primary" htmlType="submit" >
                Submit
              </Button>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 1 }} style={{ marginTop:'29px' }}>
            <Form.Item>
              <Button type="primary" htmlType="reset" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Col>

        </Row>
      </Form>
      
      <Table
        className="custom-table-wrapper"
        columns={columns}
        dataSource={data}
        size="small"
       scroll={{x: 'max-content'}}
        // rowKey= 'jobNumber'
        onRow={(record) => ({
          style: {
            backgroundColor: record.result === "FAIL" ? "rgba(255, 0, 0, 0.2)" : "transparent",
          },
        })}
        // onChange={onChange}
      />
       <Modal
                className='print-docket-modal'
                key={'modal' + Date.now()}
                width={'80%'}
                style={{ top: 30, alignContent: 'right' }}
                visible={isModalVisible}
                title={<React.Fragment>
                </React.Fragment>}
                onCancel={handleCancel}
                footer={[

                ]}
            >

                <LotDetailView lotNumber={lotINo} year={year}/>
            </Modal>
    </Card>
  );
};

export default ReportingInfo;
